import axios from "axios";
import { API_CONFIG } from '../../config/api';

export const WEATHER_API = {
    getProduct: (token: string, missionId: string, productId: string) => axios.get(
        `${API_CONFIG.HOSTNAME}${API_CONFIG.API_PREFIX}${API_CONFIG.API_VERSION}/weather/${missionId}/product/${productId}/`,
        { headers: { "Content-type": "application/json", Authorization: "Token " + token } }
    ),
};